module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQBAMAAAB8P++eAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAqUExURUdwTEeHx0aIx0uExkaIxkeIx0aHxkeIx7bc/t/w/tTo+l+Z0anO8Ii66lDTtosAAAAHdFJOUwDM8xtsbm0ycqcMAAAAxElEQVRIx2NgoAFgFSonABQTQOqYxcsJgkIDoELG6lMzCYA12wWACsN3zSQIVpcAFYqfJKxwTiFQofpKwgpnFQEVls8kApSTqhB/4JClsAMPGFU4qnBU4ajCUYXUVEj1Mpy69QzRVRzRlWY6sdUw0RU70U2F0TYFBQpnXa9eSZTC5eXlVUgKt6OGbzVC4fW9t2uJUlh+5yxGCl8NVIIR+NgUzrpdvhcjTNGsxg3aUT2DL3hqV47mQmIyFwML4S6AAy26HgBSIiXkFsAkxAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/American-Credit-Vendor-Benefits-Icon-4.png
// module id = 721
// module chunks = 5